import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../config/employeeApiConfig';


export const createexperience = createAsyncThunk(
    'experience/createexperience',
    async (data: any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.post('/experience', data);         
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create weekoff');
      }
    }
  );
export const fetchingexperience = createAsyncThunk(
    'experience/fetchingexperience',
    async (_, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.get('/experience');         
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create weekoff');
      }
    }
  );

  export const Updateexperience = createAsyncThunk(
    'experience/updateexperience',
    async ( {Id , data} : any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.put(`/experience/${Id}`, data);         
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create weekoff');
      }
    }
  );
  export const DeleteExperience = createAsyncThunk(
    'experience/deleteexperience',
    async ( Id : any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.delete(`/experience/${Id}`);         
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create weekoff');
      }
    }
  );